import { Call } from "../../api/publicCall";

export const HandlePdfUpload = async (pdfId: string) => {
  if (!pdfId) {
    alert("File non disponibile.");
    return;
  }
  try {
    const response = await Call("check/pdfDownload", "POST", { fileId: pdfId });

    if (!response.ok) throw new Error("File not found");

    const disposition = response.headers.get("Content-Disposition");
    let fileName = "file.pdf"; // fallback

    if (disposition && disposition.includes("filename=")) {
      const match = disposition.match(/filename="?(.+?)"?$/);
      if (match?.[1]) {
        fileName = match[1];
      }
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    alert("Errore nel download del file");
  }
};
